module.exports = {
  roles: {
    user: 'user',
    admin: 'admin'
  },
  item_status: {
    pending: 'pending',
    processing: 'processing',
    complete: 'complete',
    error: 'error',
    deleted: 'deleted'
  },
  project_status: {
    pending: 'pending',
    processing: 'processing',
    complete: 'complete',
    error: 'error',
    deleted: 'deleted'
  },
  voice_status: {
    pending: 'pending',
    processing: 'processing',
    complete: 'complete',
    error: 'error',
    deleted: 'deleted'
  },
  team_role: {
    admin: 'admin',
    manager: 'manager',
    member: 'member'
  }
}
